import styled from 'styled-components'

const VideoPlayerContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

const VideoContainer = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
`

const Video = styled.video`
  width: 100%;
  height: 100%;
  ::-webkit-media-controls {
    display: none !important;
  }
`

const VideoControls = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 200;
  color: #fff;
  padding: 0px 16px 12px 16px;
  background-color: #000;
  opacity: ${(props) => (props.isVisible ? '1' : '0')};
  -webkit-tap-highlight-color: transparent;
  transition: opacity 0.25s cubic-bezier(0.25, 0.1, 0.25, 1) 0s;
`

const VideoPlaybackControls = styled.div`
  height: 38px;
  display: flex;
  align-items: center;
`

const VideoSeekBar = styled.input`
  display: block;
  user-select: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  width: 100%;
  outline: none;
  cursor: pointer;
  background: linear-gradient(
    to right,
    #fff 0%,
    #fff ${(props) => props.bgValue}%,
    rgba(255, 255, 255, 0.3) ${(props) => props.bgValue}%,
    rgba(255, 255, 255, 0.3) 100%
  );
  border-radius: 2px;
  transition: all 0.3s ease 0s;

  ::-webkit-slider-runnable-track {
    height: 2px;
    border-radius: 2px;
    border: none;
  }
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    transform: translateY(-4px);
  }
  ::-moz-range-track {
    height: 2px;
    border-radius: 2px;
    border: none;
  }
  ::-moz-range-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    transform: translateY(-4px);
  }
  ::-ms-track {
    height: 2px;
    border-radius: 2px;
    border: none;
  }
  ::-ms-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #fff;
    transform: translateY(-4px);
  }
`

const PlayAndPauseBtn = styled.button`
  all: unset;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 18px;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  transition: background-color 0.25s ease 0s;
  :hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

const MuteAndUnmuteBtn = styled.button`
  all: unset;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 18px;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin-left: 5px;
  transition: background-color 0.25s ease 0s;
  :hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

const UnmuteBtn = styled.button`
  all: unset;
  position: absolute;
  top: 2%;
  left: 2%;
  z-index: 310;
  cursor: pointer;
  border-radius: 2px;
  user-select: none;
  background-color: #fff;
  color: #000;
  padding: 10px 16px;
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  border-radius: 4px;
  span{
    margin-left: 8px;
  }
`

const FullScreenBtn = styled.button`
  all: unset;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 18px;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin-right: 5px;
  transition: background-color 0.25s ease 0s;
  :hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

const CloseVideoPlayerBtn = styled.button`
  all: unset;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 18px;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  margin-left: 5px;
  transition: background-color 0.25s ease 0s;
  :hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

const VideoTimings = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-left: auto;
  padding: 0px 8px 0px 0px;
  user-select: none;
`

const Time = styled.div`
  color: #fff;
  :last-of-type {
    margin-left: 4px;
  }
`

export {
  VideoPlayerContainer,
  VideoContainer,
  Video,
  VideoControls,
  VideoPlaybackControls,
  VideoSeekBar,
  PlayAndPauseBtn,
  FullScreenBtn,
  MuteAndUnmuteBtn,
  UnmuteBtn,
  CloseVideoPlayerBtn,
  VideoTimings,
  Time,
}
